import { colors } from '../../styles/theme';

interface Item {
  icon: string;
  title: string;
  body: string;
}

/** Trust signals shown on the pre-approval engagement dashboard. The
 *  copy is intentionally short — these are reinforcement, not the
 *  primary message; the simulator and progress card carry the main
 *  pitch. Inline-rendered (no card wrapper) so it sits flush against
 *  the bottom of the dashboard without extra visual weight. */
const ITEMS: ReadonlyArray<Item> = [
  {
    icon: '🛡',
    title: 'Dual-control on every movement',
    body: 'No single person can move client money: every operation requires a second, independent approval.',
  },
  {
    icon: '📋',
    title: 'Tamper-proof records',
    body: 'Every transaction is recorded in an append-only ledger, reconciled daily, and reflected in your monthly statement.',
  },
  {
    icon: '🔒',
    title: 'Bank-level security',
    body: 'AES-256 encryption and multi-factor authentication protect your account and every approval.',
  },
];

export default function TrustStrip(): JSX.Element {
  return (
    <section
      className="rounded-2xl p-6"
      style={{
        background: colors.surface,
        border: `1px solid ${colors.border}`,
      }}
      aria-label="Why investors trust QMI"
    >
      <div
        className="grid gap-6"
        style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))' }}
      >
        {ITEMS.map((item) => (
          <div key={item.title} className="flex items-start gap-3">
            <div className="text-2xl" aria-hidden>{item.icon}</div>
            <div className="min-w-0">
              <h4
                className="text-sm font-semibold mb-0.5"
                style={{ color: colors.ink }}
              >
                {item.title}
              </h4>
              <p className="text-xs" style={{ color: colors.muted }}>
                {item.body}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
